module.exports = __webpack_public_path__ + "img/avatar3.4bdbaeaa.png";